<template>
  <div class="examStudent">
    <el-card>
      <el-row :gutter="20" v-auth="'examStudent_/examStudent/pageList'">
        <el-col :sm="12" :md="4" :lg="4">
          <el-cascader
            clearable
            style="width: 100%"
            v-model="searchForm.courseIds"
            :show-all-levels="false"
            :props="subjectTreeProps"
            placeholder="请选择所属课程"
            :options="subjectTreeList"
            @change="searchSubjectChange(searchForm.courseIds)"
          ></el-cascader>
        </el-col>
        <el-col :sm="12" :md="4" :lg="4">
          <el-select
            style="width: 100%"
            clearable
            v-model="searchForm.examSettingId"
            placeholder="请选择考试期数"
            @change=";(page.pageNumber = 1), pageList(), findExamData()"
          >
            <el-option
              v-for="item in examSearchSettingList"
              :key="item.id"
              :label="'第' + item.sequence + '期'"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <!-- <el-col :sm="12" :md="4" :lg="4">
          <el-cascader
            style="width:100%;"
            clearable
            v-model="searchForm.campusId"
            :show-all-levels="false"
            :props="CampusProps"
            placeholder="请选择所属校区"
            :options="campusHeaderList"
            @change="searchCampusChange(searchForm.campusId)"
          ></el-cascader>
        </el-col>
        <el-col :sm="12" :md="4" :lg="4">
          <el-select
            placeholder="请选择所属班级"
            style="width:100%"
            v-model="searchForm.classInfoId"
            clearable
            @change="pageList()"
          >
            <el-option
              v-for="item in classInfoList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col> -->
        <el-col :sm="12" :md="4" :lg="4">
          <el-input
            v-model="searchForm.name"
            placeholder="请输入学员姓名/手机号"
            @blur="page.pageNumber = 1"
          ></el-input>
        </el-col>
        <el-col :sm="12" :md="4" :lg="4" style="text-align: left">
          <el-button type="primary" @click="pageList">查询</el-button>
        </el-col>
        <!-- <el-col :sm="12" :md="12" :lg="6" v-if="timeTrue == true">
          <div class="examStudent-text2">距离报名结束：{{examTime}}</div>
        </el-col>-->
      </el-row>
    </el-card>
    <el-card class="box-card">
      <el-row>
        <el-col :span="18" v-if="timeTrue == true" style="display: flex">
          <div style="font-size: 14px; line-height: 40px">
            报名人数：{{ page.total }}
          </div>
          <div class="examStudent-text">
            报名时间：{{ timeData.signBeginTime }} 至 {{ timeData.signEndTime }}
          </div>
        </el-col>
        <el-col :span="timeTrue ? 6 : 24" style="text-align: right">
          <el-button
            type="primary"
            @click=";(addFormVisible = true), getSubjectTreeList()"
            icon="el-icon-plus"
            v-auth="'examStudent_/examStudent/addExamStudent'"
            >添加报名</el-button
          >
        </el-col>
      </el-row>
      <el-table
        v-auth="'examStudent_/examStudent/pageList'"
        ref="multipleTable"
        :data="page.rows"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
      >
        <el-table-column
          show-overflow-tooltip
          prop="createTime"
          label="报名时间"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="student.name"
          label="用户名"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="student.mobile"
          label="手机号"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="student.card"
          label="身份证"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="classInfo.campusName"
          label="所属校区"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.student.campusName == null">无</span>
            <span v-else>{{ scope.row.student.campusName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="classInfo.name"
          label="班级"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.classInfo == null">无</span>
            <span v-else>{{ scope.row.classInfo.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="classInfo.subjectCourseName"
          label="考试课程"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.examSetting == null">无</span>
            <span v-else>{{ scope.row.examSetting.subjectCourse.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="examSetting.sequence"
          label="考试期数"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.examSetting == null">无</span>
            <span v-else>第{{ scope.row.examSetting.sequence }}期</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="historyCount"
          sortable
          label="历史记录"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="
                historyDetailShow(scope.row.student, scope.row.historyCount)
              "
              >{{ scope.row.historyCount }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="examType" label="考试类型">
          <template slot-scope="slot">
            <span v-if="slot.row.examType == 1">仿真模考</span>
            <span v-if="slot.row.examType == 2">随到随考</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop
          label="操作"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <el-button @click="reexamine(scope.row.id)">重考</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop label="操作" width="120" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <el-button type="text" @click="getAgentRoleInfo(scope.row.id)">编辑</el-button>
              <el-button type="text" @click="deleteAgentRoleInfo(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>-->
      </el-table>
      <el-pagination
        v-auth="'examStudent_/examStudent/pageList'"
        background
        layout="prev, pager, next, jumper,  total, sizes"
        style="margin-top: 20px; text-align: left"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
    <el-dialog
      class="addDialog"
      title="添加报名"
      width="400px"
      :visible.sync="addFormVisible"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="按学员添加" name="first">
          <el-form
            :model="addForm"
            status-icon
            :rules="rules"
            ref="addForm"
            label-width="80px"
            class="demo-ruleForm"
            v-if="activeFirstTrue == false"
          >
            <el-form-item label="考试课程" prop="courseIds">
              <el-cascader
                clearable
                style="width: 100%"
                v-model="addForm.courseIds"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请选择考试课程"
                :options="subjectTreeExamList"
                @change="subjectChange(addForm.courseIds)"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="考试类型" prop="examType">
              <el-select
                style="width: 100%"
                clearable
                v-model="addForm.examType"
                placeholder="请选择考试类型"
                @change="getExamSettingListForSign()"
              >
                <el-option
                  v-for="item in examType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="考试期数" prop="examSettingId">
              <el-select
                style="width: 100%"
                clearable
                v-model="addForm.examSettingId"
                placeholder="请选择考试期数"
              >
                <el-option
                  v-for="item in examSettingList"
                  :key="item.id"
                  :label="'第' + item.sequence + '期'"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开通用户" prop="remarks">
              <!--  @keyup.enter.native="getMobiless" -->
              <el-input
                @blur="getMobiles"
                rows="5"
                type="textarea"
                v-model="addForm.remarks"
                placeholder="请输入学员手机号，添加多个学员时用空格符分开"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="examStudent-addStudent">
            <el-button @click="addFormVisible = false">取消</el-button>
            <el-button
              type="primary"
              @click="addExamStudent"
              :disabled="!checkedNum"
              >提交</el-button
            >
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="按班级添加" name="second">
          <el-form
            :model="addForm"
            status-icon
            :rules="rules"
            ref="addForm"
            label-width="80px"
            class="demo-ruleForm"
            v-if="activeFirstTrue == true"
          >
            <el-form-item label="所属校区" prop="campusId">
              <el-cascader
                style="width:100%;"
                clearable
                v-model="addForm.campusId"
                :show-all-levels="false"
                :props="CampusProps"
                placeholder="请选择所属校区"
                :options="campusList"
                @change="getClassInfoList(addForm.campusId)"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="所属班级" prop="classInfoId">
              <el-select
                placeholder="请选择所属班级"
                style="width:100%"
                v-model="addForm.classInfoId"
                clearable
              >
                <el-option
                  v-for="item in classInfoList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="考试课程" prop="courseIds">
              <el-cascader
                clearable
                style="width:100%"
                v-model="addForm.courseIds"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请选择考试课程"
                :options="subjectTreeExamList"
                @change="subjectChange(addForm.courseIds)"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="考试期数" prop="examSettingId">
              <el-select
                style="width:100%"
                clearable
                v-model="addForm.examSettingId"
                placeholder="请选择考试期数"
              >
                <el-option
                  v-for="item in examSettingList"
                  :key="item.id"
                  :label="'第' + item.sequence + '期'"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="examStudent-addStudent">
            <el-button @click="addFormVisible = false">取消</el-button>
            <el-button type="primary" @click="addExamStudent">提交</el-button>
          </div>
        </el-tab-pane> -->
      </el-tabs>
    </el-dialog>
    <el-dialog
      :title="viewFormVisibleName"
      class="viewForm"
      :visible.sync="viewFormVisible"
      width="400px"
      left
    >
      <div v-for="(item, index) in historyDetail" :key="index">
        <div class="examStudent-border">
          <span style="margin-left: 10px; font-size: 14px"
            >第{{ index + 1 }}次考试</span
          >
        </div>
        <div class="examStudent-text3">考试时间：{{ item.examBeginTime }}</div>
        <div class="examStudent-text3">
          考试课程：{{ item.subjectCourseName }}
        </div>
        <div class="examStudent-text3">考试成绩：{{ item.examScore }}分</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      changeCourseId: '',
      examType: [
        {
          id: '1',
          name: '仿真模考'
        }, {
          id: '2',
          name: '随到随考'
        }],
      visibleReexa: false,
      blockAddExamStudent: false,
      checkedNum: true,
      activeName: "first",
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      classInfoList: [],
      subjectTreeList: [],
      subjectTreeExamList: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      CampusProps: {
        value: "id",
        children: "children",
        label: "name",
      },
      viewFormVisibleName: "",
      viewFormVisible: false,
      addFormVisible: false,
      editFormVisible: false,
      historyDetail: [],
      searchForm: {
        examSettingId: "",
        classInfoId: "",
      },
      pageSearchForm: {},
      addForm: {
        examSettingId: "",
        remarks: null,
        courseIds: null,
        remark: null,
        examType: '1'
      },
      campusList: [],
      campusHeaderList: [],
      examSettingList: [],
      examSearchSettingList: [],
      mobiles: [],
      timeData: {},
      examTime: "",
      timeTrue: false,
      activeFirstTrue: false,
      editForm: {
        resource: [],
      },
      rules: {
        remarks: [
          {
            required: true,
            message: "请输入学员手机号",
            trigger: "blur",
          },
        ],
        courseIds: [
          {
            required: true,
            message: "请选择考试课程",
            trigger: "change",
          },
        ],
        examSettingId: [
          {
            required: true,
            message: "请选择考试期数",
            trigger: "change",
          },
        ],
        examType: [
          {
            required: true,
            message: "请选择考试类型",
            trigger: "change",
          },
        ],
        classInfoId: [
          {
            required: true,
            message: "请选择所属班级",
            trigger: "change",
          },
        ],
        campusId: [
          {
            required: true,
            message: "请选择所属校区",
            trigger: "change",
          },
        ],
      },
      formLabelWidth: "80px",
      loading: false,
    };
  },
  methods: {
    reexamine (id) {
      this.$confirm("确定要重考吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.api.agentRoleInfo
          .examStudent({
            id: id,
          })
          .then((result) => {
            if (result.code == 200) {
              this.$message.success('操作成功')
            } else {
              this.$message.error(result.message)
            }
            visibleReexa = false
          })
          .catch((error) => {
            console.log(error);
          });
      });

    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    getAgentRoleInfo (id) {
      this.api.agentRoleInfo
        .getAgentRoleInfo({
          id: id,
        })
        .then((result) => {
          this.editForm = result.data;
          this.editFormVisible = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    searchCampusChange (item) {
      if (typeof item == "object") {
        this.getClassInfoList(item);
        this.searchForm.classInfoId = "";
        this.pageList();
      }
    },
    searchSubjectChange (item) {
      if (typeof item == "object") {
        this.page.pageNumber = 1;
        this.getExamSettingList(item[2]);
        this.searchForm.examSettingId = "";
        this.timeTrue = false;
        this.timeData = {};
      }
    },
    subjectChange (item) {
      if (typeof item == "object") {
        this.getExamSettingListForSign(item[2]);
        if (this.addForm.examSettingId != "" && this.addForm.examSettingId != null) {
          this.addForm.examSettingId = "";
        }
      } else {
        this.getExamSettingListForSign(item);
        this.addForm.examSettingId = "";
      }
    },
    findExamData () {
      for (let item of this.examSettingList) {
        if (this.searchForm.examSettingId == item.id) {
          this.timeData = item;
          this.timeTrue = true;
          this.getExamTime();
        }
      }
      if (this.searchForm.examSettingId == "") {
        this.timeTrue = false;
      }
    },
    getExamTime () {
      this.temp = setInterval(() => {
        this.$set(
          this,
          "examTime",
          this.countDownFun(new Date(this.timeData.signEndTime).getTime())
        );
      }, 1000);
    },
    // 获取课程
    getSubjectTreeList () {
      this.api.examSetting
        .getSubjectCourseExamCount()
        .then((result) => {
          if (result.success) {
            this.subjectTreeExamList = result.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取校区
    getHeaderCampusList () {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusHeaderList = result.data;
          // this.searchForm.campusId = this.campusHeaderList[0].children[0].children[0].id;
          // this.getSubjectCourseExamCount();
          this.api.classInfo.getClassInfoList().then((resu) => {
            if (resu.success) {
              this.classInfoList = resu.data;
              // this.searchForm.classInfoId = this.classInfoList[0].id;
            } else {
              this.$message.error(resu.message);
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getSubjectCourseExamCount () {
      this.api.examSetting
        .getSubjectCourseExamCount()
        .then((result) => {
          if (result.success) {
            this.subjectTreeList = result.data;
            this.searchForm.courseIds = this.subjectTreeList[0].children[0].children[0].id;
            this.api.examSetting
              .getExamSettingList({ courseId: this.searchForm.courseIds })
              .then((result) => {
                if (result.success) {
                  this.examSearchSettingList = result.data;
                  this.examSettingList = result.data;
                  this.searchForm.examSettingId = this.examSettingList[0].id;
                  this.findExamData();
                  this.pageList();
                } else {
                  this.$message.error(result.message);
                }
              });
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getExamSettingListForSign (courseId) {
      if (courseId) {
        this.changeCourseId = courseId
      }
      this.api.examSetting
        .getExamSettingListForSign({ courseId: this.changeCourseId, examType: this.addForm.examType })
        .then((result) => {
          if (result.success) {
            this.examSettingList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getExamSettingList (courseId) {
      this.api.examSetting
        .getExamSettingList({ courseId: courseId })
        .then((result) => {
          if (result.success) {
            this.examSearchSettingList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCampusList () {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    historyDetailShow (val, count) {
      if (count == 0) {
        this.$message.warning("此学员暂无考试记录！");
      } else {
        // this.getHistoryExercise(val);
        this.goHistoryExercise(val);
      }
    },
    goHistoryExercise (val) {
      this.$router.push({
        path: "/historyExercise",
        query: {
          id: val.id,
        },
      });
    },
    getHistoryExercise (val) {
      this.api.examStudent.getHistoryExercise({ studentId: val.id }).then((result) => {
        this.historyDetail = result.data;
        this.viewFormVisibleName = val.name;
        this.viewFormVisible = true;
      });
    },
    pageList () {
      this.loading = true;
      this.pageSearchForm.pageSize = this.page.pageSize;
      this.pageSearchForm.pageNumber = this.page.pageNumber;
      if (this.searchForm.examSettingId != "") {
        this.pageSearchForm.examSettingId = this.searchForm.examSettingId;
      }
      if (this.searchForm.name != "") {
        this.pageSearchForm.name = this.searchForm.name;
      }
      if (this.searchForm.classInfoId != "") {
        this.pageSearchForm.classInfoId = this.searchForm.classInfoId;
      }
      if (typeof this.searchForm.campusId == "object") {
        this.pageSearchForm.campusId = this.searchForm.campusId[2];
      }
      if (typeof this.searchForm.courseIds == "object") {
        this.pageSearchForm.courseId = this.searchForm.courseIds[2];
      } else {
        this.pageSearchForm.courseId = this.searchForm.courseIds;
      }
      this.api.examStudent
        .pageList(this.pageSearchForm)
        .then((result) => {
          this.loading = false;
          this.pageSearchForm = {};
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addExamStudent () {
      if (this.blockAddExamStudent) {
        return false;
      }
      this.blockAddExamStudent = true;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addForm.courseId = this.addForm.courseIds[2];
          this.addForm.remark = this.addForm.remarks.replace(/[\r\n]/g, " ");
          // this.addForm.remark = this.addForm.remarks;
          this.api.examStudent
            .addExamStudent(this.addForm)
            .then((result) => {
              if (result.success) {
                this.$message.success(result.message);
                this.addFormVisible = false;
                this.blockAddExamStudent = false;
                this.pageList();
              } else {
                this.blockAddExamStudent = false;
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateAgentRoleInfo () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editForm.agentId = this.loginData.agentId;
          this.api.agentRoleInfo
            .updateAgentRoleInfo(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteAgentRoleInfo (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.agentRoleInfo
            .deleteAgentRoleInfo([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                const totalPage = Math.ceil((this.page.total - 1) / this.page.pageSize);
                const pagenum =
                  this.page.pageNumber > totalPage ? totalPage : this.page.pageNumber;
                this.page.pageNumber = pagenum < 1 ? 1 : pagenum;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },

    reset () {
      this.$refs.searchForm.resetFields();
      this.page.pageSize = 10;
      this.page.pageNumber = 1;
      this.page.sortName = "";
      this.page.sortOrder = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    getClassInfoList (id) {
      this.api.classInfo
        .getClassInfoList({ campusId: id[2] })
        .then((result) => {
          if (result.success) {
            this.classInfoList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleClick (tab, event) {
      if (tab.name == "first") {
        this.getSubjectTreeList();
        this.addForm = {};
        this.activeFirstTrue = false;
      }
      if (tab.name == "second") {
        this.activeFirstTrue = true;
        this.addForm = {};
        this.getSubjectTreeList();
        this.getCampusList();
      }
    },

    checkedUser (element) {
      console.log(123132131);
      let addSty = true;
      this.mobiles.forEach((item) => {
        if (item == element) {
          this.$message.warning(element + "此用户已存在！！！");
          addSty = false;
        }
      });
      if (addSty) {
        this.mobiles.push(element);
      }
      console.log(this.mobiles);
    },
    getMobiles () {
      this.checkedNum = true;
      this.mobiles = [];
      let mobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      let card = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; // 身份证
      let key = this.addForm.remarks;
      if (this.addForm.remarks.indexOf(",") > -1) key = key.replace(/,/g, "\n");
      if (this.addForm.remarks.indexOf("，") > -1) key = key.replace(/，/g, "\n");
      if (this.addForm.remarks.indexOf(" ") > -1) key = key.replace(/ /g, "\n");
      let arr = key.split(/[(\r\n)\r\n]+/);
      console.log(arr, "arr");
      let type = "";
      arr.forEach((item, index) => {
        if (index == 0) {
          // 判断第一个是 手机号还是 身份证
          if (mobile.test(item)) type = "mobile";
          else if (card.test(item)) type = "card";
          else {
            this.$message.error(item + "请统一输入手机号或者身份证号！！！");
            this.checkedNum = false;
            return;
          }
        }
        if (this.checkedNum) {
          if (type == "mobile") {
            if (!mobile.test(item)) {
              if (item) {
                this.$message.error(item + "请统一输入手机号或者身份证号！！！");
                this.checkedNum = false;
                return;
              }
            } else this.checkedUser(item);
          } else if (type == "card") {
            if (!card.test(item)) {
              if (item) {
                this.$message.error(item + "请统一输入手机号或者身份证号！！！");
                this.checkedNum = false;
                return;
              }
            } else this.checkedUser(item);
          }
        }
      });
      // arr.forEach(item => {
      //   if (mobile.test(item) || card.test(item)) {
      //     // 匹配手机 和 身份证 OK
      //     let addSty = true;
      //     this.mobiles.forEach(element => {
      //       if (item == element) {
      //         this.$message.warning(item + "此电话号码已存在！！！");
      //         addSty = false;
      //       }
      //     });
      //     if (addSty) {
      //       this.mobiles.push(item);
      //     }
      //   } else {
      //     // 匹配错误
      //     this.$message.error(item + "格式不正确！！！");
      //   }
      // })
      // console.log(arr);

      // this.mobiles = [];
      // this.addForm.remarks.replace(/[&\|\\\*^%$#@\-]/g, "").trim();
      // let zs = /^[1-9]\d*|0$/;
      // let names = "";
      // for (var index in this.addForm.remarks) {
      //   if (zs.test(this.addForm.remarks[index])) {
      //     names = this.addForm.remarks[index] + names;
      //   }
      // }

      // names = names
      //   .split("")
      //   .reverse()
      //   .join("")
      //   .split("");
      // for (var i = 10; i < names.length; i += 11) names[i] += " ";
      // names = names.join("");
      // let arr = names.split(" ");
      // let mobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      // let card = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;  // 身份证
      // arr.forEach(element => {
      //   if (mobile.test(element) || card.test(element)) {
      //     // 匹配任意一个
      //     console.log(element, '1111');
      //   } else console.log(element, '2222');

      //   if (!mobile.test(element)) {
      //     if (element) {
      //       this.$message.error(element + "格式不正确！！！");
      //     }
      //   } else {
      //     let addSty = true;
      //     this.mobiles.forEach(item => {
      //       if (item == element) {
      //         this.$message.warning(element + "此电话号码已存在！！！");
      //         addSty = false;
      //       }
      //     });
      //     if (addSty) {
      //       this.mobiles.push(element);
      //     }
      //   }
      // });
    },
    getMobiless () {
      this.mobiles = [];
      this.addForm.remarks.replace(/[&\|\\\*^%$#@\-]/g, "").trim();
      let zs = /^[1-9]\d*|0$/;
      let names = "";
      for (var index in this.addForm.remarks) {
        if (zs.test(this.addForm.remarks[index])) {
          names = this.addForm.remarks[index] + names;
        }
      }

      names = names.split("").reverse().join("").split("");
      for (var i = 10; i < names.length; i += 11) names[i] += " ";
      names = names.join("");
      let arr = names.split(" ");
      let mobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      arr.forEach((element) => {
        if (!mobile.test(element)) {
          if (element) {
            this.$message.error(element + "格式不正确！！！");
          }
        } else {
          let addSty = true;
          this.mobiles.forEach((item) => {
            if (item == element) {
              this.$message.warning(element + "此电话号码已存在！！！");
              addSty = false;
            }
          });
          if (addSty) {
            this.mobiles.push(element);
          }
        }
      });
    },
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.activeName = "first";
        this.activeFirstTrue = false;
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
        if (
          this.searchForm.courseIds != null &&
          this.searchForm.courseIds != [] &&
          this.searchForm.courseIds != ""
        ) {
          this.addForm.courseIds = this.searchForm.courseIds;
          this.subjectChange(this.searchForm.courseIds);
          // if(this.searchForm.examSettingId!=null&&this.searchForm.examSettingId!=[]&&this.searchForm.examSettingId!=''){
          //   this.addForm.examSettingId = this.searchForm.examSettingId;
          // }
        }
        this.activeName = "first";
        this.activeFirstTrue = false;
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.activeName = "first";
        this.activeFirstTrue = false;
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.activeName = "first";
        this.activeFirstTrue = false;
      }
    },
    viewFormVisible: function (newVal) {
      if (!newVal) {
        this.historyDetail = {};
        this.viewFormVisibleName = "";
      } else {
      }
    },
  },
  mounted () {
    // this.pageList();
    this.getHeaderCampusList();
    this.getSubjectCourseExamCount();
  },
};
</script>
<style scoped>
.examStudent-text {
  line-height: 40px;
  font-size: 14px;
  margin-left: 20px;
}
.examStudent-text2 {
  line-height: 40px;
  font-size: 14px;
  color: #4d94ff;
}
.examStudent-text3 {
  font-size: 14px;
  margin-top: 10px;
}
.examStudent-addStudent {
  margin-top: 20px;
  text-align: right;
}
.examStudent-border {
  border-left: 2px solid rgba(77, 148, 255, 1);
  font-size: 14px;
  font-weight: 600;
  margin-top: 10px;
}
</style>
<style lang="less" rel="stylesheet/less">
.examStudent {
  .addDialog {
    .el-dialog__body {
      padding-top: 10px !important;
    }
  }
  .viewForm {
    .el-dialog__body {
      padding-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fullTruthModelTest/examStudent.vue